module.exports = __webpack_public_path__ + "img/marketList.57184cb5.png";